import $ from 'jquery';
import {Modal} from 'bootstrap'
import './libs/slick.js'
import globalJS from './global.js'
import 'jquery-ui/dist/jquery-ui.min.js'
import 'jquery-lazy';

window.$ = $;
window.jQuery = $;

window.loadPropertyMap = loadPropertyMap;


let scheduleACallModal = null;

function loadPropertyMap(){
    if($("#location-map").length) {
        var data = $("#location-map").data();
        globalJS.initializeMap(data.latitude, data.longitude, $('#location-map').get(0), data.icon);
    }
}

const header = $('.header-container');
const headerLogo = header.find('.header-logo-img');
const scrollHeightToShowBackground = 500;


// console.log($(this).offsetY);
// $(window).scroll(function () {
//     const scrollTop = $(this).scrollTop();
//
//     if(scrollTop < scrollHeightToShowBackground) {
//         header.css({
//             'background': 'none',
//             'boxShadow': 'none'
//         })
//         headerLogo.attr('src', '/images/logo/trano_logo_black.png');
//         header.removeClass('scrolled');
//         return ;
//     }
//     const opacity = Math.min(scrollTop / scrollHeightToShowBackground, 2); // Calculate opacity based on scroll position
//
//     console.log(opacity);
//
//     let color = null;
//     let boxShadow = null;
//
//     if(opacity < 0.2) {
//         color = `rgba(242, 246, 247, 1)`;
//         boxShadow = 'none';
//
//     }
//     else {
//         color = `rgba(255, 255, 255, ${opacity})`;
//         boxShadow = '0 0 40px 1px #dadada';
//     }
//
//     header.css({
//         'box-shadow': boxShadow,
//         'background': color
//     });
//     headerLogo.attr('src', '/images/logo/trano_logo_black.png');
//
//     header.addClass('scrolled');
//     // header.css('background-color', 'rgba(255, 255, 255, 1)');
// });


$(document).on('click', '.js-whatsapp-btn', function(e) {

    e.preventDefault();

    let link = $(this).attr('data-href');

    globalJS.gaSubmitEvent('WHATSAPP_CHAT_INITIATED');
    globalJS.fbSubmitEvent('WHATSAPP_CHAT_INITIATED');
    setTimeout(function() {
        window.location.href = link;
    }, 200);
});

$(document).on('click', '.js-call-now-btn', function(e) {
    globalJS.gaSubmitEvent('CALL_NOW_INITIATED');
    globalJS.fbSubmitEvent('CALL_NOW_INITIATED');
});

$(document).on('click', '.read-more', function(e){
    e.preventDefault();

    var $moreText = $(this).parent().prev('.high-text').find('.more');
    var $img = $(this).find('img');
    let upArrrowImgPath = $(this).data('up-arrow');
    let downArrrowImgPath = $(this).data('down-arrow');

    // console.log($moreText.is(':hidden')+'');

    if ($moreText.is(':hidden')) {
        $moreText.slideDown();
        $img.attr('src', upArrrowImgPath);
    }
    else {
        $moreText.slideUp();
        $img.attr('src', downArrrowImgPath);
    }
});

window.addEventListener('load', function() {
    var tag = document.createElement("script");
    tag.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&callback=loadPropertyMap`;
    document.getElementsByTagName("head")[0].appendChild(tag);
});

$(document).ready(function(){

    $('img.lazy').Lazy();


    // Show modal after 10 seconds (10000 milliseconds)
    setTimeout(function() {
        showGetInTouchModal();
    }, 10000);

    // Slide In from the Left
    // $("#slideLeft").click(function() {
    //     $("#myDiv").show("slide", { direction: "left" }, 1000);
    // });


    // Slide In from the Top
    // $("#slideUp").click(function() {
    //     $("#myDiv").show("slide", { direction: "up" }, 1000);
    // });

    // Slide In from the Bottom
    // $("#slideDown").click(function() {
    //     $("#myDiv").show("slide", { direction: "down" }, 1000);
    // });

    if($('.hero-form-based-container').length > 0) {
        $(".hero-form-container").show("slide", { direction: "right" }, 1000);
        // $(".hero-slider").show("slide", { direction: "left" }, 1000);
    }

    $(".page-loader-wrapper").hide();
    // console.log('jquery works');

    $('.hero-slider').slick({
        autoplay: false,   // Auto-play the slider
        dots: false,       // Show pagination dots
        arrows: false,     // Show navigation arrows
        infinite: true,   // Loop the slider
        speed: 1000,       // Transition speed in milliseconds
        slidesToShow: 1,  // Number of slides to show at a time
        slidesToScroll: 1 // Number of slides to scroll at a time
    });

    $('.prop-image-slider-mobile').slick({
        autoplay: false,   // Auto-play the slider
        dots: true,       // Show pagination dots
        arrows: false,     // Show navigation arrows
        infinite: true,   // Loop the slider
        speed: 1000,       // Transition speed in milliseconds
        slidesToShow: 1,  // Number of slides to show at a time
        slidesToScroll: 1 // Number of slides to scroll at a time
    }).on('afterChange', function (event, slick, currentSlide) {
        $('.img-curr-count').text(currentSlide + 1); // Adding 1 to make it 1-based index
    });

    // Add click event listeners to the navigation arrows
    $(document).on('click', '.prev-arrow', function() {
        $('.hero-slider').slick('slickPrev');
    });

    $(document).on('click', '.next-arrow', function() {
        $('.hero-slider').slick('slickNext');
    });

    scheduleACallModal =  new Modal($('#schedule-a-call-modal'), {
        backdrop: 'static',
        keyboard: false
    });

    // globalJS.displayMessageToast('Thank you for registering with us, our team will reach out to you shortly', 'sucesss');
});

$(document).on('click', '.schedule-a-call-btn', function () {
    showScheduleACallModal();
});

function showScheduleACallModal() {
    scheduleACallModal.show();
}


$('.slider-single').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    infinite: true,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
});

$('.slider-nav').slick({
    slidesToShow: 9,
    slidesToScroll: 9,
    dots: false,
    arrows:false,
    focusOnSelect: false,
    infinite: false,
    vertical:true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.prop-image-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.prop-thumbs-wrapper').slick('slickGoTo', currentSlide);
    var currrentNavSlideElem = '.prop-thumbs-wrapper .slick-slide[data-slick-index="' + currentSlide + '"]';
    $('.prop-thumbs-wrapper .slick-slide.is-active').removeClass('is-active');
    $(currrentNavSlideElem).addClass('is-active');
});

$('.more-img-overlay').click(function(e){
    var $moreImagesBlock = $(this).parent().parent().find('.more-images-block');
    $moreImagesBlock.hide();
    var $scrollHeightValue = $moreImagesBlock.parent().find('.slick-list').height();
    var $slickList = $moreImagesBlock.parent().find('.slick-list');
    $moreImagesBlock.parent().find('.slick-list').css("overflow-y","scroll");
    $slickList.animate({
        scrollTop: $scrollHeightValue
    }, 2000);
});

$('.prop-thumbs-wrapper').on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');
    $('.prop-image-slider').slick('slickGoTo', goToSingleSlide);
});


/* ------------------------IMAGE POPUP SLIDER----------------------------------
------------------------------------------------------------------------------*/

$(document).on('click', '.prop-image-slider .prop-card-img', function() {
    $("#propery_image_popup").data('order', $(this).closest('.wrapper').data('order'));
    $("#propery_image_popup").modal('show');
});

var screen_height = $(window).height();

if ($('#propery_image_popup').length > 0) {
    $('#propery_image_popup').on('shown.bs.modal', function () {
        var initModalHeight = $(this).find('.modal-dialog').outerHeight(); //give an id to .mobile-dialog
        var userScreenHeight = screen_height;
        if (initModalHeight > userScreenHeight) {
            $(this).find('.modal-dialog').css('overflow', 'auto'); //set to overflow if no fit
        } else {
            $(this).find('.modal-dialog').css('margin-top',
                (userScreenHeight / 2) - (initModalHeight / 2)); //center it if it does fit
        }
        $('body').addClass('modal-open');
    });
    $('.modal').on('hidden.bs.modal', function () {
        $('body').removeClass('modal-open');
    });
}

var proeprtyImagesliderExist = false;
$('.popup-image-wrapper-block-wrapper').on('init', function(event, slick){
    proeprtyImagesliderExist = true;
    $(".popup-image-wrapper-block-wrapper .slick-next").focus();
});
$('.popup-image-wrapper-block-wrapper').on('afterChange', function(event, slick){
    $(".popup-image-wrapper-block-wrapper .slick-next").focus();
});
$('#propery_image_popup').on('shown.bs.modal', function () {
    $('.popup-image-wrapper-block-wrapper').removeClass('hide');
    $('.close-modal').removeClass('hide');
    var sliderIndex = $('#propery_image_popup').data('order');
    if(!sliderIndex){
        sliderIndex = 0;
    }
    if(proeprtyImagesliderExist){
        $('.popup-image-wrapper-block-wrapper').slick('slickGoTo', sliderIndex, true);
    }else{
        $('.popup-image-wrapper-block-wrapper').slick({
            dots: false,
            arrows:true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            autoplaySpeed:5000,
            initialSlide: sliderIndex,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }
});

$('.floor-plan-slider').slick({
    autoplay: false,   // Auto-play the slider
    dots: false,       // Show pagination dots
    arrows: true,     // Show navigation arrows
    infinite: true,   // Loop the slider
    speed: 100,       // Transition speed in milliseconds
    slidesToShow: 1,  // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
});

$(document).ready(function() {
    $('.tab').click(function(e) {
        e.preventDefault();
        $('.tab').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').removeClass('active');

        let id = $(this).attr('id');
        $('#'+id+'-content').addClass('active');
    });
});
